import {
  call,
  put,
  takeLatest,
  takeEvery,
  takeLeading,
  all
} from 'redux-saga/effects';

import { customerId } from 'common/helpers/tokenHelper';
import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';
import { LIST_CLUB_MEMBER_SHIPMENTS_SUCCESS } from 'redux/clubMemberShipments/constants';
import { getVirtualCart as getVirtualCartForTraditionalShipment } from 'redux/clubMemberShipments/sagas';
import { LIST_CLUB_PACKAGES_SUCCESS } from 'redux/clubPackages/constants';
import { LIST_CLUB_SUBSCRIPTION_SHIPMENTS_SUCCESS } from 'redux/clubSubscriptionShipments/constants';
import { getVirtualCart as getVirtualCartForSubscriptionShipment } from 'redux/clubSubscriptionShipments/sagas';
import { LIST_CLUBS_SUCCESS } from 'redux/clubs/constants';

import {
  listClubMemberships,
  getClubMembership,
  editClubMembership,
  cancelClubMembership,
  addClubMembershipHold,
  editClubMembershipHold
} from './api';
import {
  LIST_CLUB_MEMBERSHIPS_REQUEST,
  GET_CLUB_MEMBERSHIP_REQUEST,
  GET_CLUB_MEMBERSHIP_SUCCESS,
  LIST_CLUB_MEMBERSHIPS_SUCCESS,
  RESET_CLUB_MEMBERSHIP_ISFETCHING,
  EDIT_CLUB_MEMBERSHIP_REQUEST,
  CANCEL_CLUB_MEMBERSHIP_REQUEST,
  ADD_CLUB_MEMBERSHIP_HOLD_REQUEST,
  CLUB_MEMBERSHIP_OBJECT_REQUESTING,
  CLUB_MEMBERSHIP_LIST_REQUESTING,
  EDIT_CLUB_MEMBERSHIP_HOLD_REQUEST
} from './constants';

function* list(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_MEMBERSHIP_LIST_REQUESTING });
    const response = yield call(
      listClubMemberships,
      customerId(),
      action.queryString
    );
    yield call(listPayload, response.data);
  } catch (error) {
    yield put({ type: RESET_CLUB_MEMBERSHIP_ISFETCHING });
    yield call(addAPIError, error);
  }
}

export function* listPayload(payload) {
  yield call(updateClubPackages, payload.clubMemberships);
  yield call(updateClubMemberShipments, payload.clubMemberships);
  yield call(updateClubSubscriptionShipments, payload.clubMemberships);
  yield call(updateClubs, payload.clubMemberships);
  // eslint-disable-next-line no-param-reassign
  payload.clubMemberships = payload.clubMemberships.map((clubMembership) => {
    const newMembership = transformMembership(clubMembership);
    return newMembership;
  });
  yield put({
    type: LIST_CLUB_MEMBERSHIPS_SUCCESS,
    payload
  });
}

function* updateClubPackages(clubMemberships) {
  const clubPackages = [];
  clubMemberships.forEach((clubMembership) => {
    if (clubMembership.clubPackage) {
      clubPackages.push(clubMembership.clubPackage);
    }
  });
  yield put({
    type: LIST_CLUB_PACKAGES_SUCCESS,
    payload: { clubPackages }
  });
}

function* updateClubs(clubMemberships) {
  const clubs = [];
  clubMemberships.forEach((clubMembership) => {
    if (clubMembership.club) {
      clubs.push(clubMembership.club);
    }
  });
  yield put({
    type: LIST_CLUBS_SUCCESS,
    payload: { data: clubs }
  });
}

function* updateClubMemberShipments(clubMemberships) {
  const clubMemberShipments = [];
  clubMemberships.forEach((clubMembership) => {
    if (clubMembership.clubMemberShipment) {
      clubMemberShipments.push(clubMembership.clubMemberShipment);
    }
  });
  yield put({
    type: LIST_CLUB_MEMBER_SHIPMENTS_SUCCESS,
    payload: { clubMemberShipments }
  });
}

function* updateClubSubscriptionShipments(clubMemberships) {
  const clubSubscriptionShipments = [];
  clubMemberships.forEach((clubMembership) => {
    if (clubMembership.clubSubscriptionShipment) {
      clubSubscriptionShipments.push(clubMembership.clubSubscriptionShipment);
    }
  });
  yield put({
    type: LIST_CLUB_SUBSCRIPTION_SHIPMENTS_SUCCESS,
    payload: { clubSubscriptionShipments }
  });
}

function* get(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_MEMBERSHIP_OBJECT_REQUESTING });
    const response = yield call(getClubMembership, action.clubMembershipId);
    yield call(updateClubPackages, [response.data]);
    yield call(updateClubMemberShipments, [response.data]);
    yield call(updateClubSubscriptionShipments, [response.data]);
    yield call(updateClubs, [response.data]);
    const newMembership = transformMembership(response.data);
    yield put({
      type: GET_CLUB_MEMBERSHIP_SUCCESS,
      payload: newMembership
    });
    return newMembership;
  } catch (error) {
    yield put({ type: RESET_CLUB_MEMBERSHIP_ISFETCHING });
    yield call(addAPIError, error);
    return null;
  }
}

function* edit(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_MEMBERSHIP_OBJECT_REQUESTING });
    yield call(
      editClubMembership,
      customerId(),
      action.clubMembershipId,
      action.data
    );
    const newMembership = yield call(get, {
      clubMembershipId: action.clubMembershipId
    });

    if (action.onSuccess) {
      // get virtual cart if it is subscription shipment
      if (newMembership?.activeClubSubscriptionShipmentId) {
        yield call(getVirtualCartForSubscriptionShipment, {
          clubSubscriptionShipmentId:
            newMembership.activeClubSubscriptionShipmentId
        });
      }
      // get virtual cart if it is traditional shipment
      if (newMembership?.activeClubMemberShipmentId) {
        yield call(getVirtualCartForTraditionalShipment, {
          clubMemberShipmentId: newMembership.activeClubMemberShipmentId
        });
      }

      action.onSuccess(newMembership);
    }
  } catch (error) {
    yield put({ type: RESET_CLUB_MEMBERSHIP_ISFETCHING });
    yield call(addAPIError, error);
    if (action.onError) {
      action.onError(error);
    }
  }
}

function* cancel(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_MEMBERSHIP_OBJECT_REQUESTING });
    yield call(
      cancelClubMembership,
      customerId(),
      action.clubMembershipId,
      action.data
    );
    const newMembership = yield call(get, {
      clubMembershipId: action.clubMembershipId
    });

    if (action.onSuccess) {
      action.onSuccess(newMembership);
    }
  } catch (error) {
    yield put({ type: RESET_CLUB_MEMBERSHIP_ISFETCHING });
    yield call(addAPIError, error);
    if (action.onError) {
      action.onError(error);
    }
  }
}

function* addHold(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_MEMBERSHIP_OBJECT_REQUESTING });
    yield call(
      addClubMembershipHold,
      customerId(),
      action.clubMembershipId,
      action.data
    );
    const newMembership = yield call(get, {
      clubMembershipId: action.clubMembershipId
    });
    if (action.onSuccess) {
      action.onSuccess(newMembership);
    }
  } catch (error) {
    yield put({ type: RESET_CLUB_MEMBERSHIP_ISFETCHING });
    yield call(addAPIError, error);
    if (action.onError) {
      action.onError(error);
    }
  }
}

const transformMembership = (clubMembership) => {
  const newMembership = clubMembership;
  if (newMembership.clubPackage) {
    newMembership.activeClubPackageId = newMembership.clubPackage.id;
    delete newMembership.clubPackage;
  }
  if (newMembership.clubMemberShipment) {
    newMembership.activeClubMemberShipmentId =
      newMembership.clubMemberShipment.id;
    delete newMembership.clubMemberShipment;
  }
  if (newMembership.clubSubscriptionShipment) {
    newMembership.activeClubSubscriptionShipmentId =
      newMembership.clubSubscriptionShipment.id;
    delete newMembership.clubSubscriptionShipment;
  }
  return newMembership;
};

function* editHold(action) {
  try {
    yield call(removeAPIError);
    yield call(
      editClubMembershipHold,
      customerId(),
      action.clubMembershipId,
      action.id,
      action.data
    );
    const newMembership = yield call(get, {
      clubMembershipId: action.clubMembershipId
    });
    if (action.onSuccess) {
      action.onSuccess(newMembership);
    }
  } catch (error) {
    yield put({ type: RESET_CLUB_MEMBERSHIP_ISFETCHING });
    yield call(addAPIError, error);
    if (action.onError) {
      action.onError(error);
    }
  }
}

function* watchList() {
  yield takeLeading(LIST_CLUB_MEMBERSHIPS_REQUEST, list);
  yield takeLatest(GET_CLUB_MEMBERSHIP_REQUEST, get);
  yield takeEvery(EDIT_CLUB_MEMBERSHIP_REQUEST, edit);
  yield takeLatest(CANCEL_CLUB_MEMBERSHIP_REQUEST, cancel);
  yield takeLatest(ADD_CLUB_MEMBERSHIP_HOLD_REQUEST, addHold);
  yield takeLatest(EDIT_CLUB_MEMBERSHIP_HOLD_REQUEST, editHold);
}

export default function* clubMembershipSagas() {
  yield all([watchList()]);
}
